import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AUTH_ROUTES } from 'src/infrastructure/routes/auth';
import { CATEGORY_ROUTES } from 'src/infrastructure/routes/category';
import { GROUPS_ROUTES } from 'src/infrastructure/routes/group';
import { INVITES_ROUTES } from 'src/infrastructure/routes/invites';
import { LAYOUT_ROUTES } from 'src/infrastructure/routes/layoutes';
import { ODRER_ROUTES } from 'src/infrastructure/routes/order';
import { PARTNER_ROUTES } from 'src/infrastructure/routes/partner';
import { PAYMENTS_ROUTES } from 'src/infrastructure/routes/payments';
import { PRODUCT_ROUTES } from 'src/infrastructure/routes/product';
import { RETURNS_ROUTES } from 'src/infrastructure/routes/returns';
import { REVIEW_ROUTES } from 'src/infrastructure/routes/reviews';
import { USER_ROUTES } from 'src/infrastructure/routes/user';
import { RedirectComponent } from './redirect/redirect.component';


const routes: Routes = [
  {
    path: '', redirectTo: 'bottomtabs/home', pathMatch: 'full'
  },
  {
    path: 'redirect', component: RedirectComponent
  },
  ...AUTH_ROUTES,
  ...LAYOUT_ROUTES,
  ...USER_ROUTES,
  ...PRODUCT_ROUTES,
  ...PARTNER_ROUTES,
  ...CATEGORY_ROUTES,
  ...INVITES_ROUTES,
  ...PAYMENTS_ROUTES,
  ...ODRER_ROUTES,
  ...REVIEW_ROUTES,
  ...RETURNS_ROUTES,
  ...GROUPS_ROUTES
];




@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'disabled'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
